import { render, staticRenderFns } from "./CompanyUser.vue?vue&type=template&id=326955b2"
import script from "./CompanyUser.vue?vue&type=script&lang=js"
export * from "./CompanyUser.vue?vue&type=script&lang=js"
import style0 from "./CompanyUser.vue?vue&type=style&index=0&id=326955b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports